import 'reflect-metadata'

import { Expose } from 'class-transformer'

export class LastAction {
  @Expose()
  public action: string
  @Expose()
  public amount: number

  constructor() {
    this.action = ''
    this.amount = 0
  }
}
